import { Handle } from '@xyflow/react';
import { Box, Text } from '@mantine/core';
import { memo } from 'react';

import FlowStepIcon from './FlowStepIcon';

const StartNode = memo(({ data, onNodeSelect, isConnectable }) => {
  return (
    <>
      <Box ta="center" onClick={onNodeSelect} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 4 }}>
        <FlowStepIcon icon={data.custom.key} />
        <Text size="sm" component="span">{data.label}</Text>
      </Box>
      <Handle
        type="source"
        position="bottom"
        isConnectable={isConnectable}
        style={{ bottom: '-5px', width: '10px', height: '10px' }}
      />
    </>
  );
});

export default StartNode;
